// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0c2880ba","239":"b03d8db0","732":"acfaab4e"}[chunkId] + ".chunk.js";
};